module.exports = __webpack_public_path__ + "img/spin-btn.5d4851a2.png";